module.exports = __webpack_public_path__ + "static/media/Devices-unsupport.834192ca.png";